import React from 'react';
import { ScrollDirection, useScrollDirection } from 'hooks/useScrollDirection';

import { Content } from '@radix-ui/react-accordion';
import classNames from 'classnames';
import styles from './ScommesseAccordionContent.module.scss';

export type ScommesseAccordionContentProps = {
  children: React.ReactNode;
  isVirtual?: boolean;
  childrenClassName?: string;
  containerClassName?: string;
  isVisualizzazioneEstesa?: boolean;
};

// eslint-disable-next-line react/display-name
export const ScommesseAccordionContent = React.forwardRef<HTMLDivElement, ScommesseAccordionContentProps>(
  ({ ...props }, forwardedRef) => {
    const { scrollDir } = useScrollDirection();
    return (
      <Content
        ref={forwardedRef}
        suppressHydrationWarning
        className={classNames(styles.container, props.containerClassName ?? '', {
          [styles.containerVirtual]: props.isVirtual,
        })}
      >
        <div
          className={classNames(styles.childrenContainer, props.childrenClassName ?? '', {
            [styles.scrolledUp]: scrollDir === ScrollDirection.UP,
            [styles.full]: props.isVisualizzazioneEstesa,
          })}
        >
          {props.children}
        </div>
      </Content>
    );
  }
);